@switch (variant()) {
  @case ('stroked') {
    <!-- Botón normal -->
    @if (!isLink()) {
      <button
        mat-stroked-button
        [ngClass]="[computedClasses()]"
        [disabled]="disabled() || loading()"
        [type]="type()"
        [attr.aria-label]="effectiveAriaLabel()"
        (click)="onClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </button>
    }

    <!-- Enlace externo -->
    @if (isLink() && href()) {
      <a
        mat-stroked-button
        [ngClass]="[computedClasses()]"
        [href]="disabled() || loading() ? null : href()"
        [target]="target()"
        [attr.aria-label]="effectiveAriaLabel()"
        [attr.aria-disabled]="disabled() || loading()"
        [class.disabled]="disabled() || loading()"
        (click)="onClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </a>
    }

    <!-- Enlace con Router (interno) -->
    @if (isLink() && routerLink()) {
      <a
        mat-stroked-button
        [ngClass]="[computedClasses()]"
        [routerLink]="disabled() || loading() ? null : routerLink()"
        [queryParams]="queryParams()"
        [queryParamsHandling]="queryParamsHandling()"
        [attr.aria-label]="effectiveAriaLabel()"
        [attr.aria-disabled]="disabled() || loading()"
        [class.disabled]="disabled() || loading()"
        (click)="onClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </a>
    }
  }

  @case ('flat') {
    <!-- Botón normal -->
    @if (!isLink()) {
      <button
        mat-flat-button
        [ngClass]="[computedClasses()]"
        [disabled]="disabled() || loading()"
        [type]="type()"
        [attr.aria-label]="effectiveAriaLabel()"
        (click)="onClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </button>
    }

    <!-- Enlace externo -->
    @if (isLink() && href()) {
      <a
        mat-flat-button
        [ngClass]="[computedClasses()]"
        [href]="disabled() || loading() ? null : href()"
        [target]="target()"
        [attr.aria-label]="effectiveAriaLabel()"
        [attr.aria-disabled]="disabled() || loading()"
        [class.disabled]="disabled() || loading()"
        (click)="onClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </a>
    }

    <!-- Enlace con Router (interno) -->
    @if (isLink() && routerLink()) {
      <a
        mat-flat-button
        [ngClass]="[computedClasses()]"
        [routerLink]="disabled() || loading() ? null : routerLink()"
        [queryParams]="queryParams()"
        [queryParamsHandling]="queryParamsHandling()"
        [attr.aria-label]="effectiveAriaLabel()"
        [attr.aria-disabled]="disabled() || loading()"
        [class.disabled]="disabled() || loading()"
        (click)="onClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </a>
    }
  }

  @case ('icon') {
    <!-- Botón normal -->
    @if (!isLink()) {
      <button
        mat-icon-button
        [ngClass]="[computedClasses()]"
        [disabled]="disabled() || loading()"
        [type]="type()"
        [attr.aria-label]="effectiveAriaLabel()"
        (click)="onClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </button>
    }

    <!-- Enlace externo -->
    @if (isLink() && href()) {
      <a
        mat-icon-button
        [ngClass]="[computedClasses()]"
        [href]="disabled() || loading() ? null : href()"
        [target]="target()"
        [attr.aria-label]="effectiveAriaLabel()"
        [attr.aria-disabled]="disabled() || loading()"
        [class.disabled]="disabled() || loading()"
        (click)="onClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </a>
    }

    <!-- Enlace con Router (interno) -->
    @if (isLink() && routerLink()) {
      <a
        mat-icon-button
        [ngClass]="[computedClasses()]"
        [routerLink]="disabled() || loading() ? null : routerLink()"
        [queryParams]="queryParams()"
        [queryParamsHandling]="queryParamsHandling()"
        [attr.aria-label]="effectiveAriaLabel()"
        [attr.aria-disabled]="disabled() || loading()"
        [class.disabled]="disabled() || loading()"
        (click)="onClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </a>
    }
  }

  @default {
    <!-- Botón normal -->
    @if (!isLink()) {
      <button
        mat-button
        [ngClass]="[computedClasses()]"
        [disabled]="disabled() || loading()"
        [type]="type()"
        [attr.aria-label]="effectiveAriaLabel()"
        (click)="onClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </button>
    }

    <!-- Enlace externo -->
    @if (isLink() && href()) {
      <a
        mat-button
        [ngClass]="[computedClasses()]"
        [href]="disabled() || loading() ? null : href()"
        [target]="target()"
        [attr.aria-label]="effectiveAriaLabel()"
        [attr.aria-disabled]="disabled() || loading()"
        [class.disabled]="disabled() || loading()"
        (click)="onClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </a>
    }

    <!-- Enlace con Router (interno) -->
    @if (isLink() && routerLink()) {
      <a
        mat-button
        [ngClass]="[computedClasses()]"
        [routerLink]="disabled() || loading() ? null : routerLink()"
        [queryParams]="queryParams()"
        [queryParamsHandling]="queryParamsHandling()"
        [attr.aria-label]="effectiveAriaLabel()"
        [attr.aria-disabled]="disabled() || loading()"
        [class.disabled]="disabled() || loading()"
        (click)="onClick($event)"
      >
        <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
      </a>
    }
  }
}

<!-- Template del contenido del botón -->
<ng-template #buttonContent>
  <!-- Spinner de carga -->
  @if (loading()) {
    <mat-icon class="button-icon icon-left">
      <span class="button-loading-cover">
        <img src="{{ gifSource() }}" alt="Cargando..." class="button-loading-gif" />
      </span>
    </mat-icon>
  }

  <!-- Icono -->
  @if (showIcon()) {
    <mat-icon class="button-icon">
      {{ icon() }}
    </mat-icon>
  }

  <!-- Contenido del botón (texto) -->
  @if (showContent()) {
    <span class="button-content">
      <ng-content></ng-content>
    </span>
  }

  <!-- Solo icono para botones icon/fab -->
  @if (!showContent() && showIcon()) {
    <mat-icon class="button-icon">
      {{ icon() }}
    </mat-icon>
  }
</ng-template>
